import nicer from '../../../images/nicer.jpg'
import existingEmployee from '../../../images/existingEmployee.jpg'
import confetti from '../../../images/confetti.mp4'
import arrowUp from '../../../images/arrowUp.png'

import classes from './wolcome.module.css'

function Wolcome({ setEmployeeType }) {
  return (
    <div className={classes.main_container}>
      <img className={classes.first_img} src={nicer} alt="nicer" />

      <div className={classes.btn_area}>
        <div
          className={classes.img_area}
          onClick={() => {
            setEmployeeType(1)
          }}
        >
          <img src={existingEmployee} alt="existingEmployee" />
          <div dir="rtl">
            <div>
              <h3>עובדים קיימים</h3>
              <h2>באתי לבדוק משהו</h2>
            </div>
            <img className={classes.img_arrow} src={arrowUp} alt="arrowUp" />
          </div>
        </div>

        <div
          className={classes.video_area}
          onClick={() => {
            setEmployeeType(2)
          }}
        >
          <video className={classes.video} autoPlay muted loop>
            <source src={confetti} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div dir="rtl">
            <div>
              <h3>עובדים חדשים</h3>
              <h2>הרגע יצאתי מהניילונים!</h2>
            </div>
            <img className={classes.img_arrow} src={arrowUp} alt="arrowUp" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Wolcome
